<template>
  <div class="enWarehouse">
    <!-- 入库清单 -->
    <div class="log_view">
      <div class="fixed"><span class="title">入库记录</span></div>
      <dl>
        <dd v-for="(item) in log" :key="item.boxNo">
          <div class="box"><p>箱格号：{{item.boxNo}}</p><p>箱格类型：{{item.boxType}}</p></div>
          <div class="trackNum"><p>入库单号：{{item.trackNum}}</p><span>{{item.wareHourse}}</span></div>
          <div class="date"><p>入库时间：{{item.date}}</p></div>
        </dd>
      </dl>
      <div class="bot_view">
        <div class="r_btn_wrap">
          <span @click.stop="toReturn">返回</span>
          <span @click.stop="toExit">退出登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var _this
import "../../../../static/CEsite/css/common.less"
import {showLoading, hideLoading} from "../../../../static/js/utils/utility"
export default {
  data() {
    return {
      actionType: '',
      log: [{
          boxNo: '1',
          boxType: '大',
          trackNum: '100000000000086',
          wareHourse: '已入库',
          date: '2019-01-01 12:00:00'
        }, {
          boxNo: '2',
          boxType: '大',
          trackNum: '10087',
          wareHourse: '已入库',
          date: '2019-01-02 12:00:00'
        }, {
          boxNo: '3',
          boxType: '大',
          trackNum: '10088',
          wareHourse: '已入库',
          date: '2019-01-03 12:00:00'
        }, {
          boxNo: '4',
          boxType: '大',
          trackNum: '10089',
          wareHourse: '已入库',
          date: '2019-01-04 12:00:00'
        }, {
          boxNo: '5',
          boxType: '大',
          trackNum: '10090',
          wareHourse: '已入库',
          date: '2019-01-05 12:00:00'
        }, {
          boxNo: '6',
          boxType: '大',
          trackNum: '10091',
          wareHourse: '已入库',
          date: '2019-01-06 12:00:00'
        }, {
          boxNo: '7',
          boxType: '大',
          trackNum: '10092',
          wareHourse: '已入库',
          date: '2019-01-07 12:00:00'
        }, {
          boxNo: '8',
          boxType: '大',
          trackNum: '10093',
          wareHourse: '已入库',
          date: '2019-01-08 12:00:00'
        }, {
          boxNo: '9',
          boxType: '大',
          trackNum: '10094',
          wareHourse: '已入库',
          date: '2019-01-09 12:00:00'
        }, {
          boxNo: '10',
          boxType: '大',
          trackNum: '10095',
          wareHourse: '已入库',
          date: '2019-01-10 12:00:00'
        }],
    }
  },
  created() { // 发起请求，获取入库记录
    showLoading();
    this.actionType = this.$route.query.actionType;
    console.warn('记录页actionType：',this.actionType);
  },
  mounted() {
    _this = this;
    setTimeout(() => {
      hideLoading();
    }, 1000*1);
  },
  methods: {
    // 返回上一页
    toReturn() {
      _this.$router.go(-1);
    },
    // 退出登录,需要清除token
    toExit() {
      _this.$router.push({
        path: '/',
      })
    },
  }
}
</script>

<style lang="less" scoped>
.enWarehouse{
.log_view {
  width: 70%;
  overflow: hidden;
  padding-top: 0.87rem; 
  position: relative;
  background-color: rgba(255, 255, 255, 1);
  // border: 1px solid #333;
  border: 1px solid rgba(121, 121, 121, 1);
  border-radius: 0.08rem 0.08rem 0 0;
  .fixed {
    width: 100%;
    position: absolute;
    top: 0.01rem;
    // left: 0.02rem;
    text-align: center;
    padding: 0.1rem;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    .title {
      flex: 7;
      color: #333;
    }
    .log_btn {
      flex: 1;
      font-size: 0.15rem;
      line-height: 0.4rem;
      border-radius: 0.04rem;
      background-color: #409EFF;
      border-color: #409EFF;
    }
  }
  dl {
    color: #333;
    height: 6.89rem;
    overflow: hidden;
    overflow-y: auto;
    dd, dt {
      display: flex;
      padding: 0.1rem 0.5rem 0.15rem 0.5rem;
    }
    dd {
      border-top: 1px solid rgba(121, 121, 121, 1);
      justify-content: space-between;
      div {
        // display: inline-block;
        height: 100%;
      }
      .trackNum {
        width: 3.1rem;
      }
      .date p,
      .box p:first-child,
      .trackNum p:first-child {
        font-weight: bold;
        margin-bottom: 0.1rem;
      }
      .trackNum span {
        color: #fff;
        font-size: 0.13rem;
        padding: 0.05rem 0.1rem;
        border-radius: 0.04rem;
        background-color: rgba(50, 155, 0, 1);
      }
      .cancel {
        p {
          padding: 0.1rem;
          font-size: 0.13rem;
          border: 1px solid #797979;
          border-radius: 0.04rem;
        }
      }
    }
  }
  .bot_view {
    color: #333;
    display: flex;
    padding: 0.15rem;
    justify-content: flex-end;
    border-top: 1px solid #797979;
    span {
      color: #fff;
      padding: 0 0.3rem;
      display: inline-block;
      width: 1.65rem;
      height: 0.6rem;
      text-align: center;
      line-height: 0.6rem;
      font-size: 0.2rem;
      border-radius: 0.04rem;
      background-color: #409EFF;
      border-color: #409EFF;
    }
    span:nth-child(2) {
      margin-left: 0.2rem;
    }
  }
}
}
</style>





// WEBPACK FOOTER //
// src/components/CEsite/EN-warehouse/enWarehouseLog.vue